import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useAssetModalPanel } from "~/components/AssetModalV2/AssetModalPanelsContextProvider";
import { VersionList } from "~/components/AssetModalV2/VersionsPanel/components/VersionList";
import { PublicVersionsListContent } from "~/components/AssetModalV2/VersionsPanel/PublicAssetComponents/PublicVersionsListContent";
export const PublicVersionsPanel = /*#__PURE__*/ memo(()=>{
    const { showLeftPanel } = useAssetModalPanel();
    return /*#__PURE__*/ _jsx(VersionList, {
        isOpen: showLeftPanel,
        children: /*#__PURE__*/ _jsx(PublicVersionsListContent, {})
    });
});
PublicVersionsPanel.displayName = "PublicVersionsPanel";
